class FilterParsingError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ValidationError';
  }
}

export { FilterParsingError };
